export default __webpack_public_path__ + "static/media/marker-orange.5ca8c931.png";